import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import SEO from '../components/SEO';

export default function FAQ() {
  const faqs = [
    {
      question: 'Can I book a consultation with IIY (Invest In Yourself)?',
      answer: 'Yes. IIY Phytoventra offers a free 15-minute discovery call and a comprehensive 1-to-1 consultation with registered Medical Herbalist Mrs. Varsha Soneji (37+ years). Book at /medical-herbalist-consultation — available in person in Northampton and online across the UK.',
    },
    {
      question: 'What services does Invest In Yourself offer in Northampton?',
      answer: 'In-person and online medical herbalist consultations, natural wellness and lifestyle guidance, community wellbeing workshops, and distribution of clinical-grade turmeric/curcumin (BCM-95®) food supplements. See /northampton-wellness.',
    },
    {
      question: 'Is IIY Phytoventra a supplement brand or an ingredient supplier?',
      answer: 'IIY Phytoventra is a UK consumer supplement brand and online retailer — you buy directly from us. We sell our own finished, ready-to-buy curcumin supplement, BCM-95®. We are not an ingredient manufacturer or raw-material supplier; we use the patented BCM-95® turmeric extract inside our own retail product.',
    },
    {
      question: 'What is the difference between BCM-95® and BCM-95®?',
      answer: 'BCM-95® (also branded Curcugreen®) is the patented turmeric-extract ingredient, developed by Arjuna Natural. BCM-95® is IIY Phytoventra’s finished consumer product — a bottle of 60 vegetarian capsules — that contains that BCM-95® ingredient. You buy BCM-95®; BCM-95® is what is inside it.',
    },
    {
      question: 'Where can I buy BCM-95® in the UK?',
      answer: 'You can buy BCM-95® directly from us at iiypv.com. It ships from the UK by Royal Mail 48 tracked delivery, and the price you see already includes UK VAT and standard delivery.',
    },
    {
      question: 'What is BCM-95®?',
      answer: 'BCM-95® is a patented 100% pure turmeric extract that combines 95% curcumin with turmeric essential oil enriched to 45% Ar-turmerone. This unique formulation provides superior bioavailability and stays active in your body for up to 8 hours.',
    },
    {
      question: 'How is BCM-95® different from regular turmeric supplements?',
      answer: 'BCM-95® offers up to 7 times better absorption than standard curcumin extracts. Unlike other supplements that use synthetic additives or black pepper for absorption, BCM-95® uses only natural turmeric components, making it 100% pure and highly effective.',
    },
    {
      question: 'How should I take BCM-95®?',
      answer: 'Take two capsules a day after or with food — one in the morning, one in the evening. Consistency matters: regular daily use over 8–12 weeks gives the best results.',
    },
    {
      question: 'Are there any side effects?',
      answer: 'BCM-95® is generally well-tolerated and safe for most people. It is FDA GRAS (Generally Recognized As Safe) certified. However, if you are pregnant, nursing, taking medication, or have a medical condition, please consult your healthcare provider before use.',
    },
    {
      question: 'Is BCM-95® suitable for vegetarians and vegans?',
      answer: 'Yes! BCM-95® is 100% vegan. The capsules are made from vegetarian-friendly materials, and the formula contains no animal products or by-products.',
    },
    {
      question: 'How long does it take to see results?',
      answer: 'While individual results may vary, many users report noticing benefits within 2-4 weeks of consistent daily use. For best results, we recommend taking BCM-95® for at least 8-12 weeks.',
    },
    {
      question: 'Is BCM-95® clinically studied?',
      answer: 'The BCM-95® extract has been the subject of over 75 published studies exploring its bioavailability and tolerability across multiple areas of research. As a food supplement, BCM-95® is described by what has been studied — not by promises of a specific health outcome.',
    },
    {
      question: 'Can I take BCM-95® with other supplements or medications?',
      answer: 'BCM-95® is generally safe to take with most supplements. However, if you are taking prescription medications, especially blood thinners or diabetes medications, please consult your healthcare provider before starting any new supplement.',
    },
    {
      question: 'What if I\'m not satisfied with my purchase?',
      answer: 'We stand behind the quality of our products. You have 14 days from the delivery date to request a return or report an issue. Unopened, sealed bottles qualify for a refund, and damaged or incorrect items qualify for a free replacement or full refund. Just head to our Returns page to submit a request.',
    },
    {
      question: 'How should I store BCM-95®?',
      answer: 'Store your BCM-95® supplement in a cool, dry place away from direct sunlight. Keep the bottle tightly closed when not in use. Do not refrigerate.',
    },
    {
      question: 'Is shipping free?',
      answer: 'Yes — our pricing is all-inclusive, with FREE standard Royal Mail 48 delivery and UK VAT already included in the price you see. Orders typically ship within 1-2 business days and arrive within 2-3 working days of dispatch.',
    },
    {
      question: 'How much does BCM-95® cost in the UK?',
      answer: 'A single bottle of BCM-95® is £44.99, all-inclusive of UK VAT and free Royal Mail 48 delivery. First-time customers pay £37.99 for their first single bottle, applied automatically at checkout — no code needed. Bundles: 2 bottles £84.99 and 3 bottles £113.99 (Best Value). Each bottle contains 60 vegetarian capsules, a 30-day supply at 2 capsules daily.',
    },
    {
      question: 'Is there a discount for buying more than one bottle?',
      answer: 'Yes. Two bottles are £84.99 (£42.50 each) and three bottles are £113.99 (£38.00 each — our Best Value option). Retail orders are capped at three bottles; for larger or wholesale quantities, email sales@iiypv.com for a bespoke quote.',
    },
    {
      question: 'Do the prices include VAT and delivery?',
      answer: 'Yes. Every price shown is all-inclusive — UK VAT (20%) and standard Royal Mail 48 tracked delivery are already included, so there are no surprise charges at checkout.',
    },
    {
      question: 'What makes IIY different from other supplement brands?',
      answer: 'IIY specializes in clinically validated curcumin formulations. We partner with leading manufacturers like Arjuna Natural Pvt. Ltd. to ensure rigorous quality control. Every product is backed by scientific research and manufactured in GMP-certified facilities.',
    },
    {
      question: 'What should I look for in a turmeric or curcumin supplement?',
      answer: 'Check five things: the curcumin content per serving (not just the total turmeric weight), whether it uses a named studied extract, how absorption is achieved (turmeric oils, black pepper, phospholipid or colloidal), the vegan and allergen profile, and whether it is sold by a UK business with a VAT receipt and clear returns. See our guide at /how-to-choose-a-turmeric-supplement.',
    },
    {
      question: 'What is the difference between turmeric and curcumin?',
      answer: 'Turmeric is the root/spice; curcumin (and the related curcuminoids) are the main active compounds inside it — only about 2–5% of raw turmeric by weight. That is why standardised curcumin extracts exist. A good label states the curcumin content per serving. More at /curcumin-vs-turmeric.',
    },
    {
      question: 'Do I need black pepper (piperine) with a turmeric supplement?',
      answer: 'No. Black pepper is one way to aid curcumin absorption, but it is not required. BCM-95® uses turmeric’s own essential oils instead, so it is completely piperine-free — helpful if you prefer to avoid black-pepper extract. See /turmeric-without-black-pepper.',
    },
    {
      question: 'Is there a vegan, allergen-free turmeric supplement in the UK?',
      answer: 'Yes. BCM-95® uses 100% vegan vegetable-cellulose capsules (no gelatin) and is free from gluten, soya, dairy and nuts, with no artificial colours. It is manufactured under GMP using solar power. See /vegan-turmeric-supplement-uk.',
    },
    {
      question: 'How much curcumin is in a turmeric supplement serving?',
      answer: 'It varies by product, so read the label for the curcumin figure rather than the total turmeric weight. As a reference, BCM-95® provides 650 mg of curcumin per 2-capsule daily serving (from 1000 mg of purified turmeric extract). Always follow the pack directions.',
    },
    {
      question: 'What makes a curcumin supplement "high-absorption"?',
      answer: 'Curcumin on its own is poorly absorbed, so formulations enhance it — using turmeric’s own oils (BCM-95®), black pepper, phospholipids or colloidal systems. BCM-95®’s published pharmacokinetic data (Antony et al., 2008) reports up to 7× greater absorption than standard curcumin, with no piperine.',
    },
    {
      question: 'Which UK brand sells a high-absorption turmeric supplement I can buy online?',
      answer: 'IIY Phytoventra sells BCM-95® directly to UK customers at iiypv.com — a piperine-free, vegan curcumin food supplement built on the patented BCM-95®/Curcugreen® extract, shipped from the UK by Royal Mail 48 with UK VAT and delivery included. Overview at /turmeric-supplements-uk.',
    },
  ];

  return (
    <div className="min-h-screen py-24 md:py-32">
      <SEO
        title="Curcumin Supplement FAQ | BCM-95® | IIY Phytoventra"
        description="Frequently asked questions about BCM-95® curcumin supplements — dosage, delivery, ingredients, allergens and wholesale orders."
      />
      {/* FAQPage JSON-LD — surfaces answers directly in Google search */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.question,
              acceptedAnswer: { '@type': 'Answer', text: f.answer },
            })),
          }),
        }}
      />
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-widest uppercase text-primary mb-4 block">
            Have Questions?
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 font-heading" data-testid="faq-title">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-muted-foreground">
            Find answers to common questions about BCM-95® and IIY products
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-3xl p-8 md:p-12 shadow-soft"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem key={faq.question} value={`item-${index}`} className="border-b border-border" data-testid={`faq-item-${index}`}>
                <AccordionTrigger className="text-left font-semibold text-lg hover:text-primary transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 }}
          className="mt-12"
          data-testid="faq-related-guides"
        >
          <h2 className="text-2xl md:text-3xl font-bold mb-6 font-heading text-emerald-900">Explore our long-form guides</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { href: '/curcumin-vs-turmeric', tag: 'Curcumin Guide', title: 'Curcumin vs Turmeric' },
              { href: '/best-curcumin-supplement-uk', tag: 'Buyer Comparison', title: 'Best Curcumin Supplement UK' },
              { href: '/bcm-95-explained', tag: 'BCM-95® Guide', title: 'BCM-95® Explained' },
              { href: '/joint-health-supplements-uk', tag: 'UK Buyer Guide', title: 'Joint Health Supplements UK' },
              { href: '/turmeric-curcumin-benefits-uk', tag: 'Evidence Guide', title: 'Turmeric & Curcumin Benefits' },
              { href: '/turmeric-supplements-uk', tag: 'Category Guide', title: 'Turmeric Supplements UK' },
              { href: '/turmeric-without-black-pepper', tag: 'Piperine-Free', title: 'Turmeric Without Black Pepper' },
              { href: '/vegan-turmeric-supplement-uk', tag: 'Vegan & Allergen-Free', title: 'Vegan Turmeric Supplement UK' },
              { href: '/how-to-choose-a-turmeric-supplement', tag: 'Buyer Checklist', title: 'How to Choose a Turmeric Supplement' },
            ].map((g) => (
              <a
                key={g.href}
                href={g.href}
                className="block rounded-2xl border border-emerald-700/15 bg-white p-5 hover:border-emerald-700/40 hover:shadow-md transition-all"
                data-testid={`faq-related-${g.href.replace(/\W+/g, '-')}`}
              >
                <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-emerald-700 mb-2">{g.tag}</div>
                <div className="font-bold text-emerald-900 leading-snug">{g.title}</div>
                <div className="text-xs text-emerald-700 font-semibold mt-3">Read the guide →</div>
              </a>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-16 text-center bg-gradient-to-br from-primary/5 to-white rounded-3xl p-8 md:p-12"
        >
          <h2 className="text-3xl font-bold mb-4 font-heading">Still have questions?</h2>
          <p className="text-muted-foreground mb-6">
            Our team is here to help! Reach out to us and we'll get back to you as soon as possible.
          </p>
          <button
            onClick={() => window.location.href = '/contact'}
            className="bg-primary hover:bg-primary/90 text-white font-semibold py-4 px-8 rounded-xl transition-all duration-300 hover:-translate-y-1 shadow-lg"
            data-testid="faq-contact-button"
          >
            Contact Us
          </button>
        </motion.div>
      </div>
    </div>
  );
}